import { useCallback, useEffect, useState } from 'react';
import { noop } from 'lodash';

/**
 * Uses an interval-based trigger to automatically refresh the datatable. This avoids
 * having to change loading parameters or load functions which tend to have a more catestrophic
 * effect such as clearing selections or scrolling to the top.
 */
export function useIntervalRefreshTrigger(options) {
    const { interval = 1000 * 60, clearSelection = false, hardReset = false } = options || {};

    const { triggerRef, trigger } = useRefreshTrigger();

    useEffect(() => {
        if (typeof trigger !== 'function' || interval === -1) return;

        const handle = setInterval(() => trigger(clearSelection, hardReset), interval);
        return () => clearInterval(handle);
    }, [clearSelection, hardReset, interval, trigger]);

    return { triggerRef, trigger };
}

/**
 * Returns an object with a ref and function to manually trigger a reload for a datatable
 */
export function useRefreshTrigger() {
    const [trigger, setTrigger] = useState({ resetFn: noop });

    const triggerRef = useCallback((resetFn) => setTrigger({ resetFn }), []);

    return { triggerRef, trigger: trigger?.resetFn };
}
